"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var posterController_1 = require("../datalayer/posterController");
var comboEditor_1 = require("./comboEditor");
var PosterComboEditor = (function (_super) {
    __extends(PosterComboEditor, _super);
    function PosterComboEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PosterComboEditor.prototype.setPosterAdditionalInformation = function (column, rows, isPreset, row, posterController) {
        this._column = column;
        this._key = column.key.toString();
        this._rows = rows;
        this._row = row;
        this._isPreset = isPreset;
        this._posterController = posterController;
    };
    PosterComboEditor.prototype.generateKeyValuePairs = function (value) {
        if (this._key.startsWith("POSTER_")) {
            var theRow = this._rows[this._row];
            var mediumKey = _.get(theRow, "medium.key");
            if (this._isPreset) {
                var products = _.uniq(this._rows.map(function (row) {
                    return posterController_1.PosterController.getComponentsFromMediumKey(row.medium.key.toString()).type;
                }));
                if (products.length > 1 && this._key !== "POSTER_PERIOD") {
                    configuration_1.PlanConfiguration.logger.info("Editing on multiple media is not allowed!");
                    return;
                }
            }
            var components = posterController_1.PosterController.getComponentsFromMediumKey(mediumKey.toString());
            switch (this._key) {
                case "POSTER_HOUR":
                    this._display = this._posterController.getHoursObject(components.type);
                    break;
                case "POSTER_WEEKDAY":
                    this._display = this._posterController.getWeekdaysObject(components.type);
                    break;
                case "POSTER_SPOTLENGTH":
                    this._display = this._posterController.getSpotLengthsObject(components.type);
                    break;
                case "POSTER_REGION":
                    this._display = this._posterController.getRegionsObject(components.type);
                    break;
                case "POSTER_PERIOD":
                    this._display = this._column.editor.config.display;
                    break;
                default:
            }
            if (value === configuration_1.PlanConfiguration.ERROR_STRING) {
                var keys = Object.keys(this._display);
                value = this._display[keys[0]];
            }
        }
        this.displayObjectToKeyValuePairs(value);
    };
    return PosterComboEditor;
}(comboEditor_1.ComboEditor));
exports.PosterComboEditor = PosterComboEditor;
//# sourceMappingURL=posterComboEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/cellProvider/posterComboEditor.js
// module id = 18
// module chunks = 0